import React, { useRef, useState, useEffect } from "react";
import PostTab from "./PostTab";
import "./post.css";
import DynamicForm from "../form/DynamicForm.js";
import { DynamicObserver } from "../observer/DynamicObserver.js";
import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

const PostsManager = ({ posts, setPosts, activePost, setActivePost, isAutomaticCommentary, submitCallback, upgradeTmpPostId }) => {
  const tabsRef = useRef(null);
  
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  // console.log('activePost in PostsManager:', activePost);

  useEffect(() => {
    checkScrollPosition();
  }, [posts]);

  const checkScrollPosition = () => {
    if (tabsRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = tabsRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth);
    }
  };

  const scrollTabs = (direction) => {
    if (tabsRef.current) {
      const scrollAmount = 150;
      tabsRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });

      setTimeout(checkScrollPosition, 200); // Vérifier la position après le scroll
    }
  };

  const removePost = (postId) => {
    // console.log('trying to remove post with id', postId);
    setPosts((prevPosts) => {
      // console.log('previous posts:', prevPosts);
      const updatedPosts = prevPosts.filter((post) => (post.id !== postId) && (post.tmpId !== postId));

      if (activePost === postId) {
        const removedIndex = prevPosts.findIndex((post) => post.id === postId);
        const newActivePost =
          updatedPosts[removedIndex - 1]?.id || updatedPosts[removedIndex]?.id || null;
        setActivePost(newActivePost);
      }

      return updatedPosts;
    });

    setTimeout(checkScrollPosition, 200); // Vérifier la position après suppression
  };

  const updateMatchEvent = (postId, updatedEvent) => {
    setPosts((prevPosts) =>
      prevPosts.map((post) =>
        post.id === postId ? { ...post, event: updatedEvent } : post
      )
    );
  };

  const activePostObject = posts.find((p) => p.id === activePost)
  const isPopupMode = activePostObject?.showInPopup;

    useEffect(() => {
    // Si l'actif existe encore dans la liste, rien à faire
    if (posts.some(p => p.id === activePost)) return;

    // Sinon, essaie de garder l'utilisateur "dans" l'outil : sélectionne un voisin
    if (posts.length > 0) {
      // priorité au dernier (comportement naturel si l'actif vient d'être déplacé)
      setActivePost(posts[posts.length - 1].id);
    } else {
      setActivePost(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [posts]); // volontairement sans activePost/setActivePost en deps pour éviter les boucles

  return (
    <div className="posts-container">
      {!activePostObject && 
      <Box className="padding-wrapper">
        <Typography>Aucun post sélectionné</Typography>
      </Box>
      }
      <Box className="padding-wrapper">
      
      { activePostObject &&
      <div className='posts-wrapper'>
       
        <div className="tabs-wrapper">

            <button className="scroll-button scroll-button-left" onClick={() => scrollTabs("left")}  disabled={!showLeftArrow}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>

          <div className="tabs-container">
            <div className="tabs" ref={tabsRef} onScroll={checkScrollPosition}>
              
              {posts.map((post) => (
                <PostTab
                  key={post.id}
                  post={post}
                  isActive={post.id === activePost}
                  onClose={() => removePost(post.id)}
                  onSelect={() => setActivePost(post.id)}
                />
              ))}
            </div>
          </div>

            <button className="scroll-button scroll-button-right" onClick={() => scrollTabs("right")} disabled={!showRightArrow}>
              <FontAwesomeIcon icon={faChevronRight} />  
            </button>
        </div>

          {!isPopupMode ? 
            <div className="content">
              <Box className='small-padding'></Box>
              {/*POST TITLE*/}
              <Box className='medium-padding-left medium-padding-right'>
                <h2 
                style={{wordBreak: 'break-word',
                        overflowWrap: 'anywhere',
                        whiteSpace: 'normal',
                      }} className="page-subtitle">{activePostObject?.event?.tab || activePostObject?.event?.detail?.title}</h2>
              </Box>
              
              {/*POST FORM*/}
              <Box className='padding-wrapper'>
                {/* {JSON.stringify(activePostObject)} */}
                {activePostObject?.event && <DynamicForm 
                  key={activePost}
                  matchEvent={activePostObject?.event}
                  setMatchEvent={(updatedEvent) => updateMatchEvent(activePost, updatedEvent)}
                  handleClosePost={() => removePost(activePost)}
                  submitCallback={() => {
                    // console.log('callback activePost', activePost);
                    if (submitCallback) {
                      submitCallback();
                    } 
                  }}
                  upgradeTmpPostId={upgradeTmpPostId}
                  currentPostId={activePost}
                />}
                {activePostObject?.observer && <DynamicObserver item={activePostObject?.observer} action={activePostObject?.action}/>}
              </Box>

            </div>
            :
            // <Dialog open={isPopupMode} onClose={() => removePost(activePost)} maxWidth="md" fullWidth>
            <Dialog
              open={isPopupMode}
              onClose={(_, reason) => {
                // Bloque la fermeture non "explicite"
                if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
                removePost(activePost);
              }}
              disableEscapeKeyDown
              maxWidth="md"
              fullWidth
            >
              <DialogTitle>
                {activePostObject?.event.tab}
                <Button onClick={() => removePost(activePost)} color="error" sx={{ float: "right" }}>
                  X
                </Button>
              </DialogTitle>
              <DialogContent>
                <DynamicForm 
                  key={activePost}
                  matchEvent={activePostObject?.event}
                  setMatchEvent={(updatedEvent) => updateMatchEvent(activePost, updatedEvent)}
                  handleClosePost={() => removePost(activePost)}
                  onValidate={activePostObject.onValidate}
                  submitCallback={() =>submitCallback()}
                  upgradeTmpPostId={upgradeTmpPostId}
                  currentPostId={activePost}
                />
              </DialogContent>
            </Dialog>
          }
        </div>
      }
      </Box>
    </div>
  );
};

export default PostsManager;
